import { ChangeDetectionStrategy, Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UserSearchChipsDisplayComponent } from '../user-search-chips-display/user-search-chips-display.component';
import { GroupService } from '@klickdata/core/group';
import { UserService } from '@klickdata/core/user';
import { ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { User } from '@klickdata/core/user';
import { filter, takeUntil } from 'rxjs';
import { AppScope } from '@klickdata/core/resource';

@Component({
    selector: 'app-user-chip-display-with-select',
    templateUrl: './user-chip-display-with-select.component.html',
    styleUrls: ['./user-chip-display-with-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserChipDisplayWithSelectComponent extends UserSearchChipsDisplayComponent implements OnInit {
    @Output() onUpdateSelectiedUsersWithSelect: EventEmitter<{ id: number; value: boolean }[]> = new EventEmitter<
        {
            id: number;
            value: boolean;
        }[]
    >();
    public participantUsers: User[] = [];
    participantUsersForm: FormGroup;
    AppScope = AppScope;

    get participantUsersArray(): FormArray {
        return this.participantUsersForm.get('participantUsersArray') as FormArray;
    }

    constructor(
        protected groupService: GroupService,
        protected userService: UserService,
        protected cd: ChangeDetectorRef,
        protected fb: FormBuilder
    ) {
        super(groupService, userService, cd);
        this.participantUsersForm = this.fb.group({
            participantUsersArray: this.fb.array([]),
        });
    }

    ngOnInit(): void {
        if (!!this.user.group_id) {
            this.groupService
                .getGroup(this.user.group_id, 'users')
                .pipe(
                    takeUntil(this.destroy),
                    filter((group) => !!group?.users)
                )
                .subscribe((group) => {
                    this.participantUsers = group.users as unknown as User[];
                    this.participantUsers.forEach((user) => {
                        this.addUser(user);
                    });
                    this.notifyUpdates();
                });
        } else {
            this.participantUsers = [this.user];
            this.addUser(this.user);
            this.notifyUpdates();
        }
        this.participantUsersArray.valueChanges.subscribe(() => this.notifyUpdates());
    }
    public selectedUsersWithSelect(auto: MatAutocomplete, user: User): void {
        this.addUser(user);
        this.userRecieverInput.nativeElement.value = '';
        this.userCtrl.setValue('');
        auto.options.reset([]);
        this.notifyUpdates();
    }
    private addUser(user: User): void {
        this.participantUsers.push(user);
        this.participantUsersArray.push(this.createUserSelectForm({ id: user.id, value: true }));
    }
    public removeUserSelect(id: number): void {
        this.participantUsersArray.removeAt(
            this.participantUsersArray.controls.findIndex((user) => user.value.id === id)
        );
        this.participantUsers.splice(
            this.participantUsers.findIndex((user) => user.id === id),
            1
        );
        this.notifyUpdates();
    }
    private notifyUpdates() {
        this.onUpdateSelectiedUsersWithSelect.emit(
            this.participantUsersArray.value as { id: number; value: boolean }[]
        );
        this.cd.markForCheck();
    }
    private createUserSelectForm(userSelect?: { id: number; value: boolean }) {
        return this.fb.group({
            id: userSelect?.id,
            value: userSelect?.value,
        });
    }
    public getResUserById(id: number): User {
        return this.participantUsers.find((user) => user.id === id);
    }
}
